import axios, { AxiosResponse } from 'axios';
import { OwnerType } from 'types/shared/owner-type.enum';

// POST
// /ewosapi/v1/planandprognosis/startcalculation/fishgroup/{fishGroupId}
// /ewosapi/v1/planandprognosis/startcalculation/site/{localSiteId}
export const postCalculation = async (owner: OwnerType, id: string): Promise<AxiosResponse> => {
  return await axios.post<AxiosResponse>(`/ewosapi/v1/planandprognosis/startcalculation/${owner}/${id}`);
};
